// frontend/src/components/dialogs/StatusChangeConfirmDialog.js
import React from 'react';
import { LucideSave, BookX, AlertCircle } from 'lucide-react';
import { t } from 'i18next';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

const StatusChangeConfirmDialog = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    currentStatus,
    title,
    isProcessing = false 
}) => {
    const { text, cn } = useTheme();
    const isActivating = currentStatus === 'inactive';
    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={title}
            confirmVariant={isActivating ? 'primary' : 'secondary'}
            confirmIcon={LucideSave}
            cancelIcon={BookX}
            isLoading={isProcessing}
        >
            <div className="flex items-start gap-3">
                <AlertCircle className="w-6 h-6 text-yellow-500 dark:text-yellow-400 flex-shrink-0 mt-1" />
                <div>
                    <p className={cn(text.secondary)}>
                        {isActivating 
                            ? t('Are you sure you want to activate this route? This will make it available for scheduling.')
                            : t('Are you sure you want to deactivate this route? This will make it unavailable for scheduling.')}
                    </p>
                    {!isActivating && (
                        <p className="mt-2 text-sm text-orange-600 dark:text-orange-400">
                            {t('Note: Existing scheduled trips will not be affected.')}
                        </p>
                    )}
                </div>
            </div>
        </ConfirmDialogShell>
    );
};

export default StatusChangeConfirmDialog;
